import React from 'react'
import { Field } from 'redux-form'
import GridSpinner from 'components/UI/GridSpinner'
import clsx from 'clsx'
import styles from 'modules/MediaPlanner/MediaPlanner.module.scss'
import { Col, Grid, Icon, Tooltip } from 'gu-ui-kit'
import renderSelectorField from 'components/FormControls/selector'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const MonoSelector = ({
  disabled,
  options,
  loading,
  name,
  multiple,
  label,
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <Field
      disabled={disabled}
      startIcon={loading ? <GridSpinner width={24} /> : null}
      size={'l'}
      label={label}
      dropdownClassName={clsx(styles['media-planner__dropdown'])}
      name={name}
      items={options}
      fullWidth
      multiple={multiple}
      onChange={() => onChange(name)}
      renderOption={({ label, description = null }) => (
        <Grid
          wrap={false}
          justifyContent={'between'}
          alignItems={'center'}
          gap={8}
        >
          <Col flexGrow={1}>{label}</Col>
          {description && (
            <Col alignSelf={'start'}>
              <Tooltip title={description}>
                <Icon
                  className={styles['media-planner__icon']}
                  size={'m'}
                  name={'status warning'}
                  color={'Interface-Seventh'}
                />
              </Tooltip>
            </Col>
          )}
        </Grid>
      )}
      component={renderSelectorField}
      t={t}
    />
  )
}
MonoSelector.propTypes = {
  disabled: PropTypes.bool,
  options: PropTypes.array,
  loading: PropTypes.bool,
  name: PropTypes.string,
  multiple: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
}
